<div class="container">
  <div class="custom-modal">
    <div class="header header-content full-width">
      <div class="row full-width">
        <!-- <mat-icon class="big-icon text-white col-2">error</mat-icon> -->
        <div class="col-2 offset-3">
          <object
            class="error-svg"
            data="/assets/images/svg/error-icon.svg"
          ></object>
        </div>
      </div>
    </div>
    <mat-divider></mat-divider>
  </div>
  <div mat-dialog-content class="row center-content">
    <b>
      <div
        class="text-white big-font col-10 center"
        [innerHTML]="data.texto">
      </div>
    </b>
  </div>
</div>
